var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalConfirm',{attrs:{"id":"modal-confirm-claim-kas-kecil","title":"Konfirmasi Klaim Kas","desc":_vm.desc,"isSubmitting":_vm.isSubmitting},on:{"submit":function($event){return _vm.$emit('submit')}}})}
var staticRenderFns = []

export { render, staticRenderFns }